import { render } from "./AdSelectProductForm.vue?vue&type=template&id=199dbda2"
import script from "./AdSelectProductForm.vue?vue&type=script&lang=js"
export * from "./AdSelectProductForm.vue?vue&type=script&lang=js"
script.render = render

export default script